import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

const swalButtonClasses = {
        confirmButton: 'btn-danger mx-1',
        cancelButton: 'btn-secondary mx-1',
};

const swalSuccessButtonClasses = {
        confirmButton: 'btn-primary mx-1',
        cancelButton: 'btn-secondary mx-1',
};

export function confirmDelete(options: Partial<SweetAlertOptions> = {}): Promise<SweetAlertResult> {
        return Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to recover this item!',
                icon: 'warning',
                showCancelButton: true,
                customClass: swalButtonClasses,
                buttonsStyling: false,
                confirmButtonText: 'Yes, delete it!',
                ...options,
        });
}

export const showDeleteConfirmation = confirmDelete;

export function confirmAction(options: Partial<SweetAlertOptions> = {}): Promise<SweetAlertResult> {
        return Swal.fire({
                title: 'Are you sure?',
                icon: 'question',
                showCancelButton: true,
                customClass: swalSuccessButtonClasses,
                buttonsStyling: false,
                confirmButtonText: 'Yes',
                ...options,
        });
}

export function showSuccess(title: string, text?: string): Promise<SweetAlertResult> {
        return Swal.fire({
                title,
                text,
                icon: 'success',
                customClass: {
                        confirmButton: 'btn-primary',
                },
                buttonsStyling: false,
        });
}

export function showError(title: string, text?: string): Promise<SweetAlertResult> {
        return Swal.fire({
                title,
                text,
                icon: 'error',
                customClass: {
                        confirmButton: 'btn-primary',
                },
                buttonsStyling: false,
        });
}

export default Swal;
